const centerChildren = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const commonStyles = {
    container: {
        width: '100%',
        height: '100vh',
        ...centerChildren,
        flexDirection: 'column',
        gap: 20
    },
    h1: {
        fontWeight: 'bold',
        margin: '0',
    },
    h2: {
        margin: '1rem 0',
    },
    h3: {
        color: 'grey',
        margin: '.5rem 0 1rem 0',
        fontWeight: '500',
    },
    input: {
        width: '40%',
        height: '45px',
        margin: '15px 0',
    },
    aDiv: {
        width: '40%',
        height: '45px',
        display: 'flex',
        margin: '0',
        fontSize: '14px',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    button: {
        width: '40%',
        height: '45px',
        margin: '30px 0px 20px 0px',
        fontWeight: '600',
        color: 'white',
        backgroundColor: '#28282b',
    },
    image: {
        width: '150px',
        height: '150px',
        borderRadius: 12,
        objectFit: 'contain'
    },
    overlayButton: {
        width: '80px',
        height: '100%',
        fontWeight: '600',
    },
    a: {
        fontWeight: 500
    }
};

export const styles = {
    phone: {
        ...commonStyles,
        h1: {
            ...commonStyles.h1,
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',  // Using rem for fonts
        },
        h2: {
            ...commonStyles.h2,
            fontSize: 'clamp(1.8rem, 3vw, 2rem)',  // Using rem for fonts
        },
        h3: {
            ...commonStyles.h3,
            fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',  // Using rem for fonts
            margin: 0
        },
        input: {
            width: '250px',
            height: '40px',
            margin: '12px 0',
        },
        button: {
            width: '250px',
            height: '45px',
            margin: '30px 0px 10px 0px',
            fontWeight: '600',
            color: 'white',
            backgroundColor: '#28282b',
        },
        aDiv: {
            ...commonStyles.aDiv,
            width: '250px',
            height: '40px',
        },
    },

    tablet: {
        ...commonStyles,
        h1: {
            ...commonStyles.h1,
            fontSize: 'clamp(2.5rem, 4vw, 4rem)',  // Using rem for fonts
        },
        h2: {
            ...commonStyles.h2,
            fontSize: 'clamp(2.5rem, 3.5vw, 3.5rem)',  // Using rem for fonts
        },
        h3: {
            ...commonStyles.h3,
            fontSize: 'clamp(1.2rem, 2.5vw, 1.8rem)',  // Using rem for fonts
        },
    },

    desktop: {
        ...commonStyles,
        h1: {
            ...commonStyles.h1,
            fontSize: 'clamp(3rem, 5vw, 4rem)',  // Using rem for fonts
        },
        h2: {
            ...commonStyles.h2,
            fontSize: 'clamp(2.5rem, 4vw, 3rem)',  // Using rem for fonts
        },
        h3: {
            ...commonStyles.h3,
            fontSize: 'clamp(1.5rem, 3vw, 2rem)',  // Using rem for fonts
        },
    },
};
